export const API_KEY = "testnode:public:73e14b3dfdb44af0a06419237dae6dd1";
export const API_URL = "https://v4.passwordless.dev";
export const CLIENT_ID = "6f946b58a746113f58ed902943c01d22";